function VeriffTestView() {
  return <></>;
}

export default VeriffTestView;
